export const fontFamilies = [
  {
    value: 'arial,sans-serif',
    label: 'Arial'
  },
  {
    value: 'verdana,sans-serif',
    label: 'Verdana'
  },
  {
    value: 'helvetica,sans-serif',
    label: 'Helvetica'
  },
  {
    value: 'tahoma,sans-serif',
    label: 'Tahoma'
  },
  {
    value: 'trebuchet ms,sans-serif',
    label: 'Trebuchet MS'
  },
  {
    value: 'Times New Roman,serif',
    label: 'Times New Roman'
  },
  {
    value: 'georgia,serif',
    label: 'Georgia'
  },
  {
    value: 'garamond,serif',
    label: 'Garamond'
  },
  {
    value: 'courier new,monospace',
    label: 'Courier New'
  },
  {
    value: 'Brush Script MT,cursive',
    label: 'Brush Script MT'
  }
];